import LocationCreateForm from "./location-create-form";

export default LocationCreateForm;